module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "main-container"
  }, [_c('section', {
    staticClass: "mobile"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-12"
  }, [_c('div', {
    staticClass: "masthead-logo-mobile mobile"
  }, [_c('img', {
    attrs: {
      "src": 'static/img/common/logo.png'
    }
  })])])])])]), _vm._v(" "), _c('mast-head', {
    ref: "mst",
    attrs: {
      "page": "food"
    }
  }), _vm._v(" "), _c('section', [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "row intro-box"
  }, [_c('div', {
    staticClass: "col-xs-10 col-xs-offset-1 col-md-10 col-md-offset-1 text-center"
  }, [_c('h3', {
    staticClass: "h3-subtitle",
    domProps: {
      "innerHTML": _vm._s(_vm.food.subtitle)
    }
  })])])])]), _vm._v(" "), _c('section', [_c('my-carousel', {
    attrs: {
      "array": 'food_array'
    }
  })], 1), _vm._v(" "), _c('section', [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "row text-center"
  }, [_c('div', {
    staticClass: "col-md-8 col-md-offset-2 col-lg-8 col-lg-offset-2 text-center"
  }, _vm._l((_vm.food.body), function(p, index) {
    return _c('p', {
      staticClass: "page-paragraph",
      domProps: {
        "innerHTML": _vm._s(p)
      }
    })
  }))])])]), _vm._v(" "), _c('section', [_c('contact-section')], 1), _vm._v(" "), _c('section', {
    staticClass: "section-joined-bottom"
  }, [_c('text-ticker', {
    attrs: {
      "page": "food"
    }
  })], 1), _vm._v(" "), _c('section', {
    staticClass: "section-joined-top"
  }, [_c('footer-image')], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-2a314e00","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/containers/Food.vue
// module id = 139
// module chunks = 2